var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMotorbikes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Scooter-3--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Scooter 3 Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.47 7.75a1 1 0 0 0 -1 -1h-3.72a0.25 0.25 0 0 1 -0.25 -0.25v-1a5.5 5.5 0 0 0 -11 0v1a0.25 0.25 0 0 1 -0.25 0.25H2.53a1 1 0 1 0 0 2h2.66a0.26 0.26 0 0 1 0.25 0.2L7.7 19.39a2.32 2.32 0 0 0 0.9 1.39 0.29 0.29 0 0 0 0.27 0 0.25 0.25 0 0 0 0.13 -0.2v-3.43a3 3 0 0 1 1.39 -2.52 0.26 0.26 0 0 1 0.27 0l0.45 0.28a1.77 1.77 0 0 0 0.83 0.24 2 2 0 0 0 -1.94 2V22a2 2 0 0 0 4 0v-4.85a2 2 0 0 0 -2 -2 1.59 1.59 0 0 0 0.83 -0.24l0.46 -0.28a0.26 0.26 0 0 1 0.27 0A3 3 0 0 1 15 17.15v3.42a0.26 0.26 0 0 0 0.14 0.22 0.27 0.27 0 0 0 0.26 0 2.36 2.36 0 0 0 0.89 -1.38L18.54 9a0.25 0.25 0 0 1 0.24 -0.2h2.69a1 1 0 0 0 1 -1.05ZM7.38 10.83 7 9.09a1.13 1.13 0 0 1 0 -0.41L10.36 10l0.55 3Zm1.37 -4a0.25 0.25 0 0 1 -0.18 -0.08 0.26 0.26 0 0 1 -0.07 -0.17V5.5a3.5 3.5 0 0 1 7 0v1.06a0.25 0.25 0 0 1 -0.25 0.25ZM17 9.09l-0.37 1.74L13 13l0.55 -3a0.18 0.18 0 0 1 0 -0.09L17 8.68a1.12 1.12 0 0 1 0 0.41Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMotorbikes);
export default ForwardRef;